import { render, staticRenderFns } from "./ListaProducto.vue?vue&type=template&id=183661c5"
import script from "./ListaProducto.vue?vue&type=script&lang=js"
export * from "./ListaProducto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports